<template>
    <div class="Alarm">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>내 알림</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_close.png" width="50" alt="이전" />
                </a>
            </div>
            <button class="btn-alarm-read"
                    :disabled="bAlarmClickCheckd"
                    @click="setAlarmReadFunc"
            >
                모두읽음
            </button>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <div>
                <!-- s: Alarm 리스트 -->
                <ul class="li-bottom-line">
                    <li v-for="(data, index) in list" :key="index">
                        <div :class="[data.strAlarmSubTitle == 'i_reply' ? 'icon-reply' : 'icon-note',
                                        data.bAlarmClickCheckd == false ? 'on': 'off'
                                    ]"
                             @click="setAlarmClickFunc(data.nMenuNum, data.nBoardNum, data.strAlarmGubun, data.nAlarmNum, data.oAuthorizeAccessRead)">
                            <h3>
                                {{ data.strAlarmSendNickName }}
                                {{ data.strAlarmSendDated }}
                                {{data.strAlarmSendMode}}
                            </h3>
                            <h2>{{ data.strAlarmTitle }}</h2>
                        </div>
                    </li>
                </ul>
                <!-- e: Alarm 리스트 -->
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>


import EventBus from "@/plugins/eventBus";

export default {
    name: 'Alarm',
    data() {
        return {
            list:[]
        }
    },
    // 감시자
    watch: {
    },
    computed:{
        bAlarmClickCheckd(){
            // eslint-disable-next-line no-unused-vars
            let result = true;
            this.list.forEach(function (item) {
                if (item.bAlarmClickCheckd === false){
                    result = false;
                }
            })
            return result;
        }
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.getAlarmList();
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // Alarm 리스트 호출
        getAlarmList(){
            let param = {};
            param.nPage = this.page;

            this.ajaxGetAuth('/api/v1/alarm/list', param, this.getAlarmListResult);
        },
        // Alarm 리스트 결과
        getAlarmListResult(response){
            if (response.result.code == 0){
                this.list = response.oAlarm.list;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // Alarm 리스트 클릭
        setAlarmClickFunc(nMenuNum, nBoardNum, strAlarmGubun, nAlarmNum, oAuthorizeAccessRead){
            let param = {};
            param.nMenuNum = nMenuNum;
            param.nBoardNum = nBoardNum;
            param.strAlarmGubun = strAlarmGubun;
            param.nAlarmNum = nAlarmNum;
            param.oAuthorizeAccessRead = oAuthorizeAccessRead;

            this.ajaxGetAuth('/api/v1/alarm/click', param,this.setAlarmClickFuncResult);
        },
        // Alarm 리스트 클릭 결과
        setAlarmClickFuncResult(response, varParam){
            if (response.result.code == 0){
                this.slidePanelClose();

                // 쪽지로 이동
                if (varParam.strAlarmGubun == 'M'){
                    this.noteViewSlideView('receive', varParam.nBoardNum);
                // 게시글로 이동
                }else{
                    this.boardDetailMove(varParam.nMenuNum, varParam.nBoardNum, varParam.oAuthorizeAccessRead)
                }
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }

            // 메인 헤더 알람 카운트 호출
            EventBus.$emit('push-alarm-func', '');
        },
        // Alarm 모두읽기 호출
        setAlarmReadFunc(){
            let param = {};
            this.ajaxGetAuth('/api/v1/alarm/read', param, this.setAlarmReadFuncResult);
        },
        // Alarm 모두읽기 결과
        setAlarmReadFuncResult(response){
            // 메인 헤더 알람 카운트 호출
            EventBus.$emit('push-alarm-func', '');

            this.toastMsg(response.result.resultNoti.message,1500);

            if (response.result.code == 1214){
                this.getAlarmList();
            }
        },
    }
}
</script>

<style scoped>
    .btn-alarm-read{position: absolute;top: 8px;right: 15px;background: #2e9cff;color: #fff;border: 0;padding: 5px 10px;font-size: 16px;border-radius: 5px;}
    .li-bottom-line div{padding-left: 45px;background-repeat: no-repeat; background-position: center left; background-size: 38px 53px; }
    .li-bottom-line div.icon-note.on{background-image: url("../../assets/images/icon_note_on.png");}
    .li-bottom-line div.icon-note.off{background-image: url("../../assets/images/icon_note_off.png");}
    .li-bottom-line div.icon-reply.on{background-image: url("../../assets/images/icon_reply_on.png");}
    .li-bottom-line div.icon-reply.off{background-image: url("../../assets/images/icon_reply_off.png");}

    .li-bottom-line div h3{font-size: 13px; font-weight: 400; color: #737373;}
    .li-bottom-line div h2{font-size: 16px; font-weight: 500; color: #737373;text-decoration: none;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}

    .li-bottom-line div.on h3{color: #000;}
    .li-bottom-line div.on h2{color: #000;}
</style>
